module.exports = __webpack_public_path__ + "img/feature_buy_zh.5a422c27.png";